import { Switch } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import SweetAlert2 from "react-sweetalert2";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import * as actions from "../redux/PromotionAction";
import { PromotionCaptionDialog } from "./promotionCaption/PromotionCaptionDialog";
import { PromotionCopyModal } from "./PromotionCopyModal";
import { PromotionDialog } from "./promotionDetail/PromotionDialog";
import { PromotionReportModal } from "./PromotionReportModal";
import { VoucherList } from "./voucherList/VoucherList";

export const PromotionListing = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [showPromo, setShowPromo] = useState(false);
  const [showCaption, setShowCaption] = useState(false);
  const [showVoucher, setShowVoucher] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [showPromotionReport, setShowPromotionReport] = useState();
  const [promotionId, setPromotionId] = useState();
  const [swalProps, setSwalProps] = useState({});

  const columnClass = "p-3";

  const promotionState = useSelector(
    ({ promotion }) => promotion,
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchPromotionList());
  }, []);

  const handleSwitchChange = (promotionid) => {
    const updateQueryParams = {
      promotionid,
    };

    dispatch(actions.updatePromotionStatus(updateQueryParams)).then(
      handleApiResponse
    );
  };

  const handleShareCopy = (promotionid) => {
    const updateQueryParams = {
      promotionid,
    };

    dispatch(actions.updatePromotionShareCopy(updateQueryParams)).then(
      handleApiResponse
    );
  };

  const handleCopyPromo = (promotionid) => {
    const updateQueryParams = {
      promotionid,
    };

    dispatch(actions.copyPromotion(updateQueryParams)).then((resp) => {
      setShowPromo(false);
      handleApiResponse(resp, "copySuccessfully");
    });
  };

  const generateVoucher = (promotionid) => {
    const updateQueryParams = {
      promotionid,
    };

    dispatch(actions.generateVoucher(updateQueryParams)).then((resp) =>
      handleApiResponse(resp, "generateSuccessfully")
    );
  };

  const handleDelete = (promotionId) => {
    setSwalProps({
      show: true,
      icon: "question",
      title: intl.formatMessage({ id: "confirmation" }),
      text: intl.formatMessage({ id: "questionRemoveSelectedPromo" }),
      showCancelButton: true,
      onConfirm: () => {
        dispatch(
          actions.removePromotion({
            promotionid: promotionId,
          })
        ).then((resp) => {
          resp = resp.data;
          if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
            dispatch(actions.fetchPromotionList());
            setSwalProps({
              show: true,
              icon: "success",
              title: intl.formatMessage({ id: "success" }),
              text: intl.formatMessage({ id: "removePromoSuccessfully" }),
            });
          } else {
            setSwalProps({
              show: true,
              icon: "error",
              title: intl.formatMessage({ id: "error" }),
              text: resp.message,
            });
          }
        });
      },
    });
  };

  const handleApiResponse = (resp, successMsg = "updateSuccessfully") => {
    resp = resp.data;

    if (parseInt(resp.code) === ApiStatusTypeEnum.SUCCESS) {
      setSwalProps({
        show: true,
        icon: "success",
        title: intl.formatMessage({ id: "success" }),
        text: intl.formatMessage({
          id: successMsg,
        }),
        onConfirm: () => {
          dispatch(actions.fetchPromotionList());
        },
      });
    } else {
      setSwalProps({
        show: true,
        icon: "error",
        title: intl.formatMessage({ id: "error" }),
        text: resp.message,
      });
    }
  };

  const handleOpenDetail = (promotionid) => {
    setShowPromo(false);
    setIsEditable(false);
    setPromotionId(promotionid);
    setShow(true);
  };

  return (
    <div className="px-4">
      <SweetAlert2
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      {promotionState.actionsLoading && (
        <div
          className="position-fixed w-100 top-0 start-0 end-0 bottom-0 d-flex align-items-center justify-content-center"
          style={{
            scale: "1.5",
            background: "rgba(0,0,0,0.3)",
            zIndex: "9999",
          }}
        >
          <div className="spinner-border" role="status">
            <span className="sr-only"></span>
          </div>
        </div>
      )}

      <PromotionReportModal
        setShowPromotionReport={setShowPromotionReport}
        showPromotionReport={showPromotionReport}
      />
      <PromotionCopyModal
        setShowPromo={setShowPromo}
        showPromo={showPromo}
        handleCopyPromo={handleCopyPromo}
        handleOpenDetail={handleOpenDetail}
        setSwalProps={setSwalProps}
      />
      <PromotionDialog
        show={show}
        setShow={(isShow) => {
          setShow(isShow);
          if (!isEditable) {
            setShowPromo(true);
          }
        }}
        isEditable={isEditable}
        promotionId={promotionId}
        setSwalProps={setSwalProps}
        setPromotionId={setPromotionId}
      />
      <PromotionCaptionDialog
        show={showCaption}
        setShow={setShowCaption}
        promotionId={promotionId}
        setSwalProps={setSwalProps}
        setPromotionId={setPromotionId}
      />
      <VoucherList
        show={showVoucher}
        setShow={setShowVoucher}
        promotionId={promotionId}
        setSwalProps={setSwalProps}
        setPromotionId={setPromotionId}
      />
      <div className="d-flex align-items-center justify-content-between mb-4">
        <h2 className="m-0 p-0">{intl.formatMessage({ id: "promotion" })}</h2>
        <div className="d-flex gap-2">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              setShowPromo(true);
            }}
          >
            {intl.formatMessage({ id: "copyPromotion" })}
          </button>
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => {
              setIsEditable(true);
              setPromotionId(undefined);
              setShow(true);
            }}
          >
            {intl.formatMessage({ id: "createNew" })}
          </button>
        </div>
      </div>

      <div
        className="rounded table-responsive"
        style={{ background: "var(--table-background)" }}
      >
        <table className="w-100">
          <thead>
            <tr className="border-bottom">
              <th className={columnClass}>
                {intl.formatMessage({ id: "no" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "title" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "type" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "status" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "shareCopy" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "free" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "turnover" })}
              </th>
              <th className={columnClass}>
                {intl.formatMessage({ id: "action" })}
              </th>
            </tr>
          </thead>
          <tbody>
            {promotionState.promotionLists ? (
              promotionState.promotionLists.promotionLists.length > 0 ? (
                promotionState.promotionLists.promotionLists.map(
                  (promotion, index) => (
                    <tr key={promotion.promotionid} className="border-bottom">
                      <td className={columnClass}>{index + 1}</td>
                      <td className={columnClass}>
                        {promotion.promotiontitle}
                      </td>
                      <td className={columnClass}>
                        {promotion.promotiontypedscp}
                      </td>
                      <td className={columnClass}>
                        <Switch
                          checked={promotion.status === "active"}
                          onChange={() =>
                            handleSwitchChange(promotion.promotionid)
                          }
                        />
                      </td>
                      <td className={columnClass}>
                        <Switch
                          checked={promotion.sharecopy === "true"}
                          onChange={() =>
                            handleShareCopy(promotion.promotionid)
                          }
                        />
                      </td>
                      <td className={columnClass}>{promotion.free}</td>
                      <td className={columnClass}>{promotion.turnover}</td>
                      <td className={columnClass}>
                        <div className="d-flex">
                          <button
                            className="btn btn-info me-1"
                            onClick={() => {
                              setIsEditable(true);
                              setPromotionId(promotion.promotionid);
                              setShow(true);
                            }}
                            title={intl.formatMessage({ id: "editPromotion" })}
                          >
                            <i className="bi bi-pencil"></i>
                          </button>
                          <button
                            className="btn btn-warning me-1"
                            onClick={() => {
                              setPromotionId(promotion.promotionid);
                              setShowCaption(true);
                            }}
                            title={intl.formatMessage({ id: "editCaption" })}
                          >
                            <i className="bi bi-badge-cc"></i>
                          </button>
                          <button
                            className="btn btn-danger me-1"
                            onClick={() => handleDelete(promotion.promotionid)}
                            title={intl.formatMessage({
                              id: "deletePromotion",
                            })}
                          >
                            <i className="bi bi-trash text-dark"></i>
                          </button>
                          <button
                            className="btn btn-info me-1"
                            onClick={() =>
                              setShowPromotionReport(promotion.promotionid)
                            }
                            title={intl.formatMessage({
                              id: "promotionReport",
                            })}
                          >
                            <i className="bi bi-card-list text-dark"></i>
                          </button>
                          {promotion.promotiontype === "voucher" && (
                            <>
                              <button
                                className="btn btn-secondary me-1"
                                onClick={() => {
                                  setPromotionId(promotion.promotionid);
                                  setShowVoucher(true);
                                }}
                                title={intl.formatMessage({
                                  id: "viewVoucherList",
                                })}
                              >
                                <i className="bi bi-ticket-detailed"></i>
                              </button>
                              <button
                                className="btn btn-primary me-1"
                                onClick={() => {
                                  generateVoucher(promotion.promotionid);
                                }}
                                title={intl.formatMessage({
                                  id: "generateVoucher",
                                })}
                              >
                                <i className="bi bi-plus-circle"></i>
                              </button>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  )
                )
              ) : (
                <tr>
                  <td colSpan={8} className={`text-center ${columnClass}`}>
                    {intl.formatMessage({ id: "noRecordFound" })}
                  </td>
                </tr>
              )
            ) : (
              <tr>
                <td colSpan={8} className={columnClass}>
                  <div className="d-flex justify-content-center">
                    <div className="spinner-border" role="status">
                      <span className="sr-only"></span>
                    </div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
